import { useQuery } from "@tanstack/react-query";
import type { AxiosError } from "axios";
import { type FaqContent, getFaq } from "src/api/faq";
import isPes from "src/helpers/isPes";

import options from "./defaultOptions";

export const FAQ_KEY = "faq";
export const getFaqKey = () => [FAQ_KEY, isPes()];

// what the editor saves for a block without content — such blocks are hidden from regular users
export const EMPTY_FAQ_ITEM = "<p></p>";

export const useFaq = () =>
	useQuery<FaqContent[], AxiosError>({
		queryKey: getFaqKey(),
		queryFn: getFaq,
		...options,
	});
